<template>
    <div class="video-wrapper">
        <a-modal
            class="local-video"
            :visible="visible"
            :title="$t('program.local_video'/*本地录制视频*/ )"
            :width="1000"
            :maskClosable="false"
            :confirm-loading="loading"
            :footer="null"
            @cancel="visible = false">
            <a-table :columns="columns" :dataSource="videoList" :pagination="false">
                <template slot="number" slot-scope="text,record,index">
                    {{index + 1}}
                </template>

                <template slot="videoName" slot-scope="text">
                    {{text.substring(text.lastIndexOf('/') + 1, text.lastIndexOf('.'))}}
                </template>

                <template slot="size" slot-scope="text">
                    {{Number(text / 1024).toFixed(2)}}KB
                </template>

                <template slot="action" slot-scope="text, record, index">
                    <a :href="record.video_url" target="_blank">
                        {{$t('program.view')/* 查看 */}}
                    </a>
                </template>
            </a-table>
        </a-modal>
    </div>
</template>
<script>
export default {
    name: 'editSpeakModal',
    props: {
    },
    data() {
        return {
            visible: false,
            loading: false,
            columns: [
                 {
                    title: this.$t('program.number'/*序号*/ ),
                    scopedSlots: { customRender: 'number' },
                    align: 'center',
                    width: 80
                },
                {
                    title: this.$t('program.video_name'/*视频名称*/ ),
                    dataIndex: 'url',
                    scopedSlots: { customRender: 'videoName' },
                    align: 'center',
                },
                {
                    title: this.$t('program.file_size'/*文件大小*/ ),
                    dataIndex: 'size',
                    scopedSlots: { customRender: 'size' },
                    align: 'center',
                },
                {
                    title: this.$t('program.upload_time'/*上传时间*/ ),
                    dataIndex: 'modified',
                    align: 'center',
                },
                {
                    title: this.$t('layout.operation'/*操作*/ ),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    fixed: 'right',
                    width: 90
                }
            ],
            videoList: [],
        };
    },
    methods: {
        showFun() {
            this.visible = true
            this.getLocalVideoList()
        },
        getLocalVideoList () {
            this.loading = true
            this.$request.get({ url: 'getLocalVideoList' }).then((res) => {
                this.videoList = res.data
            }).finally(() => {
                this.loading = false
            })
        }
    }
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-modal-body {
    max-height: 72vh;
    overflow-y: auto;
}
</style>